// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"RO-z","inlineTitle":"SO-z","sponsoredAdsWrapper":"TO-z","marketplaceRecosWrapper":"UO-z"};